var map = {
	"./ab1.jpg": 7404,
	"./ab2.jpg": 7236,
	"./ab3.jpg": 8708,
	"./ab4.jpg": 5620,
	"./ab5.jpg": 4251,
	"./ab6.jpg": 3502,
	"./ab7.jpg": 418,
	"./ab8.jpg": 2080,
	"./ab9.jpg": 5096,
	"./xab10.jpg": 6052,
	"./yab11.jpg": 5046,
	"./zab12.jpg": 9234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5402;